<template>
  <div v-if="openStore" id="app">
    <header class="[ ui borderless main ] [ m-0 pt-4 pb-4 d-block ]">
      <div class="container">
          <div class="[ row align-items-center ]">
            <div class="col-8 [ d-block d-md-none align-items-center d-flex ]">
                 <CategoryMobile :search="search" :categoryId="categoryId" :subCategoryId="subCategoryId" :categorys="categorys" />
                  <span class="ui text medium-xl small-md ml-4">
                        <div class="dropdown">
                            <div class="[ ui inline dropdown ] [ ml-1 ] dropdown-toggle" id="dropdownLangM" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <input type="hidden" name="Currency" >
                                <div class="text">{{option.optionCurrency}}</div><i class="dropdown icon"></i>
                                <div class="menu dropdown-menu" aria-labelledby="dropdownLangM">
                                    <div v-on:click="optionCurrency('THB')" :class="{'active' : option.optionCurrency == 'THB' }" class="item" data-value="1">THB</div>
                                    <div v-on:click="optionCurrency('US')" :class="{'active' : option.optionCurrency == 'US' }" class="item" data-value="0">US</div>
                                </div>
                            </div>
                        </div>
                  </span> 
                  <span class="[ ml-xl-4 ml-4 ] ui text medium-xl small-md">
                      <div class="[ ui inline dropdown ] [ ml-1 ] dropdown-toggle" id="dropdownLangM" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <input type="hidden" name="language">
                          <div class="text">{{(option.optionLange == 'TH')? 'ไทย' : 'English'}}</div><i class="dropdown icon"></i>
                          <div class="menu dropdown-menu" aria-labelledby="dropdownLangM">
                              <div v-on:click="optionLange('TH')" :class="{'active' : option.optionLange == 'TH' }" class="item" data-value="1">ไทย</div>
                              <div v-on:click="optionLange('EN')" :class="{'active' : option.optionLange == 'EN' }" class="item" data-value="0">English</div>
                          </div>
                      </div>
                  </span>
              </div>
                <div class="col-4 col-sm-4"><a href="/"><img width="200" :src="logo"></a></div>
              <div class="col d-flex">
                <div class="[ d-none d-md-flex align-items-center ml-auto ]">
                    <span class="ui text medium-xl small-md" >
                        {{$t('Currency')}}:
                        <div class="[ ui inline dropdown ] [ ml-1 ] dropdown-toggle" id="dropdownCostW" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <input type="hidden" name="Currency">
                            <div class="text">{{option.optionCurrency}}</div><i class="dropdown icon"></i>
                            <div class="menu dropdown-menu" aria-labelledby="dropdownCostW">
                                <div v-on:click="optionCurrency('THB')" :class="{'active' : option.optionCurrency == 'THB' }" class="item" data-value="1">THB</div>
                                <div v-on:click="optionCurrency('US')" :class="{'active' : option.optionCurrency == 'US' }" class="item" data-value="0">US</div>
                            </div>
                        </div>
                    </span> 
                    <span class="[ ml-xl-4 ml-2 ] ui text medium-xl small-md">
                        {{$t('Language')}}:
                        <div class="[ ui inline dropdown ] [ ml-1 ] dropdown-toggle" id="dropdownLangW" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <input type="hidden" name="language">
                        <div class="text">{{(option.optionLange == 'TH')? 'ไทย' : 'English'}}</div><i class="dropdown icon"></i>
                        <div class="menu dropdown-menu" aria-labelledby="dropdownLangW">
                            <div v-on:click="optionLange('TH')" :class="{'active' : option.optionLange == 'TH' }" class="item" data-value="1">ไทย</div>
                            <div v-on:click="optionLange('EN')" :class="{'active' : option.optionLange == 'EN' }" class="item" data-value="0">English</div>
                        </div>
                        </div>
                    </span>
                    <router-link :to="'paymentmethod'" class="[ ui text medium-xl small-md ] [ ml-xl-4 ml-2 align-items-center d-flex ] [ color black ]" href="#">
                        <i class="dollar sign icon large color theme [ mr-0 ]"></i>
                         {{$t('MethodOfPayment')}}
                    </router-link>
                    <a v-if="web.mobile != null" class="[ ui text medium-xl small-md ] [ ml-xl-4 ml-2 align-items-center d-flex ] [ color black ]">
                        <i class="phone volume icon large color theme [ mr-0 ]"></i>{{web.mobile}}</a>
                    </div>
              </div>
          </div>
      </div>
      <div class="[ container pt-2 ] nav-custom">
          <div class="row">
                <div class="col col-3 [ d-none d-md-flex align-items-center ]">
                    <Category :search="search" :categoryId="categoryId" :subCategoryId="subCategoryId" :categorys="categorys" />
                </div>
              <div class="col-sm col-6">
                  <div class="[ d-flex align-items-center ]">
                      <div class="w-100">
                            <form class="w-100 ui input">
                                <input class="ui input border-theme text large-xl tiny py-0 br-0" type="text" v-model="search" :placeholder="$t('Search') + '...'"> 
                                <!-- <router-link :to="'/products?search=' + search" :categorys="categorys"> -->
                                    <button @click.prevent="gotoRoute()" class="ui button theme br-0 d-flex align-items-center px-xl-2 px-2 py-lg-2 pb-1 pt-2">
                                        <i class="icon-custom-search large-xl mb-2 d-block mr-1 mt-1"></i> 
                                        <span class="ui text large-xl light">{{$t('Search')}}</span>
                                    </button>
                                <!-- </router-link> -->
                            </form>
                      </div>
                  </div>
              </div>
              <div class="col-4 col-sm-4 ml-auto">
                    <div class="[ d-flex align-items-center ] text-right main-menu-list" >
                        <router-link v-if="!logged" :to="'/login'" class="[ text ] [ ml-auto text-center ] [ color gray-4 ]" href="#">
                          <i class="icon-custom-lock big-lg large [ mr-auto ml-auto d-block ]"></i> 
                          <span  class="ui text tiny-xl mini-md extra-mini light d-block mt-1">{{$t('SignIn')}}</span>
                        </router-link> 
                        <a v-if="logged" @click="logout" class="[ text ] [ ml-auto text-center ] [ color gray-4 ] pointer">
                          <i class="icon-custom-lock big-lg large [ mr-auto ml-auto d-block ]"></i> 
                          <span  class="ui text tiny-xl mini-md extra-mini light d-block mt-1">{{$t('SignOut')}}</span>
                        </a>
                        <router-link :to="'/favorite'" class="[ text ] [ ml-3 text-center d-none d-md-block ] [ color gray-4 ]" href="#">
                            <i class="icon-custom-heart big-lg large [ mr-auto ml-auto d-block ]"></i> 
                            <span class="ui text tiny-xl mini-md extra-mini light d-block mt-1">{{$t('Favorite')}}</span>
                        </router-link>
                        <router-link :to="'/cart'" class="[ text ] [ ml-1 ml-sm-3 text-center ] [ color gray-4 ] cart" href="#">
                            <i class="icon-custom-cart big-lg large [ mr-auto ml-auto d-block ]"></i> 
                            <span class="ui text tiny-xl mini-md extra-mini light d-block mt-1 ">{{$t('Cart')}}
                                <span v-if="this.cartProducts.length > 0" class="notify-cart">{{this.cartProducts.length}}</span>
                            </span>
                        </router-link>
                        <router-link v-if="logged" :to="'/profile'" class="[ text ] [ ml-3 text-center d-none d-md-block ] [ color gray-4 ]" href="#">
                            <i class="icon-custom-profile big-lg large [ mr-auto ml-auto d-block ]"></i> 
                            <span class="ui text tiny-xl mini-md extra-mini light d-block mt-1">{{$t('Profile')}}</span>
                        </router-link>
                    </div>
              </div>
          </div>
      </div>
    </header>
    <router-view/>
    <footer class="footer bg white mt-sm-5 mt-3 pt-3 pb-5">
        <div class="container">
            <div class="ui text menu">
                <router-link :to="'policy'" class="item ui text medium-sm mini ml-auto ml-lg-0">
                    <span class="color black">{{$t('Policy')}}</span>
                </router-link>
                <router-link :to="'contact'" class="item ui text medium-sm mini">
                    <span class="color black">{{$t('ContactUs')}}</span>
                </router-link>
                <router-link :to="'paymentmethod'" class="item ui text medium-sm mini">
                    <span class="color black">{{$t('MethodOfPayment')}}</span>
                </router-link>
            </div>
            <div class="row align-items-center">
                <div class="col-12 offset-lg-3 col-lg-6">
                    <p class="ui text medium-sm tiny color gray-7 light text-center">{{web.address}}</p>
                </div>
                <div class="col-12 col-lg-3 mt-3 mt-sm-0">
                    <div class="ui text menu m-0">
                        <a v-if="web.instagram" :href="web.instagram" class="item ui text large ml-auto">
                            <img src="./assets/img/icon-ig.svg"></a> 
                        <a v-if="web.line" :href="web.line" class="item ui text large">
                            <img src="./assets/img/icon-line.svg"></a> 
                        <a v-if="web.facebook" :href="web.facebook" class="item ui text large mr-auto mr-lg-0">
                            <img src="./assets/img/icon-fb.svg"></a>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-8 text-center ml-auto mr-auto">
                    <img class="mt-4" src="./assets/img/logo-footer.svg">
                </div>
            </div>
        </div>
    </footer>
    <Message :isActive="showMessage" :message="message"></Message>
  </div>
  <div v-else class="page-close">
      <div class="row h-100 d-flex align-items-center" v-if="pageClose">
          <div class="col-12 text-center ">
            <img :src="'/Shopping.png'" alt="" width="50px" height="50px">
            <h1>ขออภัย ปิดปรับปรุง</h1>
            <a href="https://wasprojects.com">www.wasprojects.com</a>
          </div>
      </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Category from '@/components/category/Category'
import CategoryMobile from '@/components/category/CategoryMobile'
import Message from '@/components/popup/Message'
import { constants } from 'fs';
import { setTimeout } from 'timers';

export default {
    name: 'app',
    components: {
        Category,
        CategoryMobile,
        Message,
    },
    data() {
        return {
            openStore: false,
            pageClose: false,
            web: {},
            logo: null,
            color:{main:"#FFF",sub:"#FFF"},
            themes: [],
            cartValue: 0,
            option: {
                optionCurrency : 'THB',
                optionLange: 'TH'
            },
            search: '',
            categorys:[],
            categoryId: 0,
            subCategoryId: 0,
            message: {
                title: '',
                message: ''
            },
            showMessage: false,
            logged: false,
            currency: "฿",
            isInitGoogle: false,
            isInitFacebook: false,
            timeOut: true,
        }
    },
    computed: mapState(["cartProducts"]),
    methods: {
        getThemes(){
            this.$http
            .get('themes')
            .then(response => {
            this.themes = response.data.data.themes
            this.web = response.data.data
            })
            .catch(error => {
                // this.openStore = false
            })
            .finally(() => this.loading = false)
        },
        /* Initially loading the cart products from local storage */
        ...mapMutations(["SET_CART_PRODUCTS"]),
        switchLocale() {
            if (this.option.optionLange === 'EN') {
                this.$i18n.locale = 'en'
            } else {
                this.$i18n.locale = 'th'
            }
        },
        gotoRoute(){
            // this.$router.push('/products?search=' + search)" :categorys="categorys";
            this.$router.push({
                name: 'product', 
                query: {
                    search: this.search,
                }
            })
        },
        getLocalProducts() {
            const products = JSON.parse(localStorage.getItem("was-cart"))
            if (products) {
                this.SET_CART_PRODUCTS(products);
            }
        },
        optionCurrency : function(el){
                this.option.optionCurrency = el
                this.saveOption()
                location.reload()
        },
        optionLange : function(el){
                this.option.optionLange = el
                this.saveOption()
                location.reload()
        },
        saveOption() {
            const optionCurrency = this.option.optionCurrency
            localStorage.setItem('optionCurrency', optionCurrency)
            const optionLange = this.option.optionLange
            localStorage.setItem('optionLange', optionLange)
        },
        checkLogged(){
            $.ajaxSetup({ cache: true });
            let accountType = localStorage.getItem('accountType')
            if(accountType == 'facebook'){
                setTimeout(()=>{
                    this.callFacebookAuth()
                },1000);
            }else if(accountType == 'google'){
                this.callGoogleAuth()
            }else if(accountType == 'email'){
                this.checkAuth()
            }
        },
        checkAuth(){
            this.$http.get('auth')
            .then(res => {
                this.logged = true
            })
            .catch(error => {
                this.logged = false
                localStorage.removeItem("_auth");
                localStorage.removeItem("accountType");
                this.$router.push('/')
            })
        },
        callFacebookAuth(){
            //facebook
            let checkGauthLoad = setInterval(()=>{
                FB.getLoginStatus(response => {
                    if (response.status === 'connected') {
                        this.isInitFacebook = true
                    }
                });
                if(this.isInitFacebook && this.timeOut) clearInterval(checkGauthLoad)
            }, 100);
        },
        callGoogleAuth(){
            let checkGauthLoad = setInterval(()=>{
                this.isInitGoogle = this.$gAuth.isInit
                // this.isSignIn = this.$gAuth.isAuthorized
                if(this.isInitGoogle && this.timeOut) clearInterval(checkGauthLoad)
            }, 100);
        },
        loginFunction(data){
            this.$http.post('login',{email: data.email,password:data.password})
            .then(response => {
                let user = response.data.data
                localStorage.setItem('_auth', user.token)
                localStorage.setItem('accountType', user.accountType)
                this.logged = true
                this.$router.push('/cart')
            })
            .catch(error => {
                if(!error.response){
                    return
                }
                let message = error.response.data.errors.message
                let snakeCase = error.response.data.errors.snakeCase
                switch (snakeCase) {
                    case 'the_email_field_is_required.':
                        message = this.$t('rqEmail')
                        // error.response.data.errors
                        break;
                    case 'the_email_field_is_required.':
                        message = this.$t('rqEmail')
                        break;
                    case 'the_password_field_is_required.':
                        message = this.$t('rqPass')
                        break;
                    case 'the_password_must_be_at_least4_characters.':
                        message = this.$t('rqPassMin',{num: 4})
                        break;
                    case 'the_email_has_already_been_taken.':
                        message = this.$t('rqEmailUnique')
                        break;
                }
                this.message.message = message
                this.showMessage = !this.showMessage
            })
            .finally(() => this.loading = false)
        },
        facebookLogin(){
            FB.login( response => {
                if (response.status === 'connected') {
                    this.facebookToken(response.authResponse.accessToken)
                }
            });
        },
        facebookToken(token){
            this.$http.post('login/facebook',{token: token})
            .then(response => {
                let user = response.data.data
                localStorage.setItem('_auth', user.token)
                localStorage.setItem('accountType', user.accountType)
                this.logged = true
                this.$router.push('/cart')
                return
            })
            .catch(error => {
                    let message = error.response.data.errors.message
                    let snakeCase = error.response.data.errors.snakeCase
                    switch (snakeCase) {
                        case 'the_email_has_already_been_taken.':
                            message = this.$t('rqEmailUnique')
                            break;
                    }
                    this.message.title = this.$t('Login')
                    this.message.message = message
                    this.showMessage = !this.showMessage
            })
            .finally(() => this.loading = false)
        },
        googleLogin(){
            this.$gAuth.signIn()
            .then(user => {
                let token = user.getAuthResponse().access_token
                this.$http.post('login/google',{token: token})
                .then(response => {
                    let user = response.data.data
                    localStorage.setItem('_auth', user.token)
                    localStorage.setItem('accountType', user.accountType)
                    this.logged = true
                    this.$router.push('/cart')
                })
                .catch(error => {
                    let message = error.response.data.errors.message
                    let snakeCase = error.response.data.errors.snakeCase
                    switch (snakeCase) {
                        case 'the_email_has_already_been_taken.':
                            message = this.$t('rqEmailUnique')
                            break;
                    }
                    this.message.title = this.$t('Login')
                    this.message.message = message
                    this.showMessage = !this.showMessage
                })
            })
        },
        logout(){
            let accountType = localStorage.getItem('accountType')
            if(accountType == 'facebook'){
                FB.logout()
            }else if(accountType == 'google'){
                this.$gAuth.signOut()
                this.isInitGoogle = false
            }
            localStorage.removeItem("_auth");
            localStorage.removeItem("accountType");
            this.logged = false
            this.$router.push('/')
        }
    },
    created() {
        $.getScript('https://connect.facebook.net/en_US/sdk.js', () =>{
                FB.init({
                    appId: this.$FB_ID,
                    version: 'v2.7' // or v2.1, v2.2, v2.3, ...
                });
        });
        this.$http
            .get('color')
            .then(response => {
                this.logo = response.data.data.logo
                let cm = response.data.data.main
                let cs = response.data.data.sub
                let style = $('<style>.color.theme{color:'+ cm +' !important}'+
                    '.ui.button.theme{background-color:'+ cm +' !important}'+
                    '.ui.input.border-theme{border-color:'+ cm +' !important}'+
                    '.main-menu-list .router-link-active,.router-link-active,.category .title > .active.text > span {color: '+ cm +' !important;}'+
                    '.notify-cart {background-color: '+ cs +' !important;}'+
                    '.ui.teal.button {background-color: '+ cs +' !important;}'+
                    '.theme.sidebar .sidebar__title {background-color: '+ cm +' !important;}'+
                    '.theme.sidebar{border-color:'+ cm +' !important}'+
                    '.progress .item.active .item__icon {background-color: '+ cm +' !important;}'+
                    '.progress .item.active .item__title {color: '+ cm +' !important;}'+
                    '.category .title > .active.text { text-decoration: '+ cm +' underline; !important;}'+
                    '.category .item.active > span,.filter__btn.active {color: '+ cm +' !important;}'+
                    '.product.type-f:hover{border-color:'+ cm +' !important}'+
                    
                    
                '</style>')
                $('html > head').append(style)
            })
            .catch(error => {
            })
        this.$http
            .post('authenticate')
            .then(response => {
                this.openStore = true
            })
            .catch(error => {
                this.openStore = false
                this.pageClose = true
            })

        this.option.optionCurrency= (localStorage.getItem('optionCurrency'))? localStorage.getItem('optionCurrency') : 'THB'
        this.option.optionLange = (localStorage.getItem('optionLange'))? localStorage.getItem('optionLange') : 'TH'
        this.getLocalProducts()
        this.saveOption()
        if(this.option.optionCurrency == 'US'){
            this.currency = "$"
        }else{
            this.currency = "฿"
        }
        this.switchLocale()
        //style scroll
        $(window).scroll(function() {
            if($(window).scrollTop() >= 150  ) {
                $('div.nav-custom').addClass('fixed');
            } else {
                $('div.nav-custom').removeClass('fixed');
            }
        });
        
        this.checkLogged()
        setTimeout(() => {
            this.timeOut = false
        }, 5000);
        this.$http
            .get('categories')
            .then(response => {
                this.categorys = response.data.data
            })
            .catch(error => console.log(error))
        
    },
    watch:{
        isInitGoogle(val){
            if(val == true){
                let token = this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse().access_token
                this.$http.post('login/google',{token: token})
                .then(response => {
                    let user = response.data.data
                    localStorage.setItem('_auth', user.token)
                    localStorage.setItem('accountType', user.accountType)
                    this.logged = true
                })
            }
        },
        isInitFacebook(val){
            if(val == true){
                this.$http.get('user/profile')
                    .then(response => {
                        this.logged = true
                    })
                    .catch(error =>{
                    })
            }else{
                localStorage.removeItem("_auth")
                localStorage.removeItem('accountType')
            }
        }
    }
}
</script>
<style lang="scss">
    .page-close{
        position: absolute;
        height: 100%;
        width: 100%;
    }
    i.large.icon, i.large.icons {
        font-size: 1em!important;
    }
    div.nav-custom{
        position: relative;
        height: 41px;
    }
    div.nav-custom.fixed{
        height: 41px;
    }
    div.nav-custom.fixed .row{
        z-index: 1000;
        position: fixed!important;
        background: #F7F7F7;
        top: -43px;
        left: 0px;
        margin: 0 auto;
        width: 100%;
        padding: 10px;
        margin-right: auto;
        margin-left: auto;
        animation: mymove .3s ease-in;
        animation-fill-mode: forwards;
        box-shadow: 0px 1px 3px 1px rgba(60, 60, 60, 0.4);
    }
    /* Safari 4.0 - 8.0 */
    @-webkit-keyframes mymove {
        from {top: -63px;}
        to {top: -0px;}
    }

    @keyframes mymove {
        from {top: -63px;}
        to {top: -0px;}
    }
</style>